import React, { Component } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
class ServiceTabExample extends Component{

    render(){
        
        /* service tab menu */
        let serviceTabMenuData = [
            {iconName: 'flaticon-002-welding', tabMenuName: 'Land Mining'},
            {iconName: 'flaticon-004-walkie-talkie', tabMenuName: 'Work Management'},
            {iconName: 'flaticon-015-cart', tabMenuName: 'Material Engineering'},
            {iconName: 'flaticon-010-tank-1', tabMenuName: 'Power and Energy'}
        ];

       

        
        /* service tab content */
        
        let serviceTabContentData = [
            // {bgUrl: "service-tab1.jpg", contentTitle: 'Land Mining', contentDesc: 'Lorem ipsum dolor sit amet, consectet adipisicin elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', serviceLink: 'service-details-left-sidebar'},
            // {bgUrl: "service-tab1.jpg", contentTitle: 'Work Management', contentDesc: 'Lorem ipsum dolor sit amet, consectet adipisicin elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', serviceLink: 'service-details-left-sidebar'},
            // {bgUrl: "service-tab1.jpg", contentTitle: 'Material Engineering', contentDesc: 'Lorem ipsum dolor sit amet, consectet adipisicin elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', serviceLink: 'service-details-left-sidebar'},
            // {bgUrl: "service-tab1.jpg", contentTitle: 'Power and Energy', contentDesc: 'Lorem ipsum dolor sit amet, consectet adipisicin elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', serviceLink: 'service-details-left-sidebar'}
            {pageLink: 'general-contracting', img: 'general-contracting.jpg', iconClass: 'fi fi-ts-user-helmet-safety', serviceTitle: 'General Contracting', serviceSubtitle: 'Management of construction projects as the primary contractor, including subcontractor procurement, construction supervision, and quality assurance.'},
            {pageLink: 'consulting-advisory-services', img: 'consulting_services.jpg', iconClass: 'fi fi-ts-department', serviceTitle: 'Consulting and Advisory Services', serviceSubtitle: 'Expertise and guidance in project feasibility assessment, risk management, regulatory compliance, sustainability strategies, and project optimization.'},
            {pageLink: 'facility-management', img: 'facility_management.jpg', iconClass: "fi fi-rr-practice", serviceTitle: 'Facilities Management', serviceSubtitle: 'FPost-construction services such as maintenance, repairs, facility upgrades, and ongoing support to ensure long-term operational efficiency and asset performance.'},
            {pageLink: 'service-details-left-sidebar', img: 'JanitorialServices.jpg', iconClass: 'fi fi-rs-clean', serviceTitle: 'Janitorial Services', serviceSubtitle: 'Our team is well known for excellence in janitorial and cleaning services. We have a customized, task specific system for each and every client site.'}
        ];
        
        let serviceTabMenuDatalist = serviceTabContentData.map((val, i)=>{
            return(
                <Tab key={i}>  <span className="icon"><i className={val.iconClass} /></span> <span className="text">{val.serviceTitle}</span></Tab>
            )
        });

        let serviceTabContentDatalist = serviceTabContentData.map((val, i)=>{
            return(
                <TabPanel key={i}>
                    <div className="service-tab__single-content-wrapper" style={{ backgroundImage: `url(assets/img/service/${val.img})` }}>
                        <div className="service-tab__single-content">
                            <h3 className="service-tab__title">{val.serviceTitle}</h3>
                            <p className="service-tab__text">{val.serviceSubtitle}</p>
                            <a href={`services/${val.pageLink}`} className="see-more-link">SEE MORE</a>
                        </div>
                    </div>
                </TabPanel>
            )
        });

        return(
            <div>

                {/*====================  service tab area ====================*/}
                <div className="service-tab-area section-space--inner--120">
                <div className="container">
                    <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title-area text-center">
                        <h2 className="section-title section-space--bottom--50">Other Services <span className="title-icon" /></h2>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        {/* service tab wrapper */}
                        
                        <div className="service-tab-wrapper">
                        <Tabs>
                            <div className="row no-gutters">
                                <div className="col-md-4">
                                    <TabList>
                                        <div className="service-tab__link-wrapper">
                                            {serviceTabMenuDatalist}
                                        </div>
                                    </TabList>
                                </div>

                                <div className="col-md-8">
                                    {serviceTabContentDatalist}
                                </div>
                            </div>
                        </Tabs>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                {/*====================  End of service tab area  ====================*/}
            </div>
        )
    }
}

export default ServiceTabExample;